export default __webpack_public_path__ + "static/media/tbc.5356f53c.svg";